/**
 * Created by Ning Jiang on 6/28/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IScreenViewConfig, ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {UserAgent} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {TimelineLite} from "gsap";
import {FruitsReelAreaView} from "../../reel/reelarea/FruitsReelAreaView";
import { Device } from "@nolimitcity/slot-launcher/bin/interfaces/APIOptions";

export abstract class BonusGameScreenView extends ScreenView {

    protected _onShowCompleteCallback:undefined | (() => void);

    constructor(config:IScreenViewConfig, autoClose:boolean = false) {
        super(config, autoClose);
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, FruitsReelAreaView.GAME_MODE_SWITCHING_COMPLETED, (event:GameEvent) => this.onGameModeSwitchCompleted(event.params[0]));
    }

    protected initAnimations():void {
        super.initAnimations();
        this.reset();
    }

    protected startPresentation(data?:ParsedServerData, onShowComplete?:() => void):void {
        this._onShowCompleteCallback = onShowComplete;
        // Wait for the reelAreaAnimation then show button.
    }

    private onGameModeSwitchCompleted(newMode:string):void {
        if(newMode != this.getNewMode()) {
            return;
        }

        let tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            this._button.visible = true;
            // this._autoCloseTimer.visible = true;
        }, 1);
        if(this._onShowCompleteCallback) {
            this._onShowCompleteCallback();
        }
    }

    protected setButtonPosition(data:IResizeData):void {
        if(UserAgent.deviceName === Device.DESKTOP) {
            this._button.position.set(this._screenWidth * 0.5, (this._screenHeight * 0.85) + 30);
        }

        else {
            this._button.position.set(this._screenWidth * 0.5, this._screenHeight * 0.85);
        }

    }

    protected stopPresentation(closeCallback?:() => void):void {
        super.stopPresentation(closeCallback);
        this.reset();
    }

    private reset():void {
        // this._autoCloseTimer.visible = false;
        this._button.visible = false;
        this._onShowCompleteCallback = undefined;
    }

    protected abstract getNewMode():string;
}